import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import DhobaraHomePage from './DhobaraHomePage';

// Dhobara custom homepage — bypasses Sharetribe PageBuilder/Console assets
// All design is controlled directly in DhobaraHomePage.js + DhobaraHomePage.module.css
export const LandingPageComponent = ({ currentUser, isAuthenticated }) => {
  return <DhobaraHomePage currentUser={currentUser} isAuthenticated={isAuthenticated} />;
};

const mapStateToProps = state => ({
  currentUser: state.user.currentUser,
  isAuthenticated: state.auth.isAuthenticated,
});

const LandingPage = compose(
  connect(mapStateToProps)
)(LandingPageComponent);

export default LandingPage;
